module.exports = __webpack_public_path__ + "img/jackpot-disable.f88fdcc2.svg";